import React, {memo} from 'react'
import {Text} from 'uikit'
import {useAppSelector} from 'store'
import {getCurrentRiddle} from 'store/secretword/selectors'
import {getTranslates} from 'store/translates/selectors'
import {isMobileUserAgent} from 'services/app'
import {Word} from './Word'
import styles from './WordBox.scss'

export const WordBox = memo(() => {
  const riddle: string = useAppSelector(getCurrentRiddle)
  const translates = useAppSelector(getTranslates)
  const isMobile = isMobileUserAgent()

  return (
    <div className={styles.wrap}>
      {!isMobile &&
        <Text type="title" color="primary">{translates.GUESS_THE_WORD}</Text>
      }
      <Text type="text" color="primary">{`${translates.PROMPT}${riddle}`}</Text>
      <Word />
    </div>
  )
})

WordBox.displayName = 'WordBox'
